document.addEventListener('DOMContentLoaded', function () {
  var mobilePanel = document.getElementById('mobile-panel');
  var searchPanel = document.getElementById('search-panel');
  var menuBtn = document.querySelector('[data-toggle-menu]');
  var searchBtn = document.querySelector('[data-toggle-search]');

  function closeAll() {
    if (mobilePanel) mobilePanel.hidden = true;
    if (searchPanel) searchPanel.hidden = true;
    if (menuBtn) menuBtn.setAttribute('aria-expanded', 'false');
    if (searchBtn) searchBtn.setAttribute('aria-expanded', 'false');
  }
  if (menuBtn) menuBtn.addEventListener('click', function () {
    var open = mobilePanel && !mobilePanel.hidden;
    closeAll();
    if (mobilePanel) mobilePanel.hidden = open;
    menuBtn.setAttribute('aria-expanded', String(!open));
  });
  if (searchBtn) searchBtn.addEventListener('click', function () {
    var open = searchPanel && !searchPanel.hidden;
    closeAll();
    if (searchPanel) searchPanel.hidden = open;
    searchBtn.setAttribute('aria-expanded', String(!open));
    if (!open && searchPanel) { var inp = searchPanel.querySelector('input'); if (inp) inp.focus(); }
  });

  // ---------- Hero slider ----------
  document.querySelectorAll('[data-hero-slider]').forEach(function (root) {
    var track = root.querySelector('[data-hero-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hero-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hero-dot]'));
    var count = slides.length;
    if (!track || count <= 1) return;
    var index = 0;
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(root.getAttribute('data-speed'), 10) || 6000;
    var timer = null;

    function goTo(i) {
      index = (i + count) % count;
      track.style.transform = 'translateX(-' + (index * (100 / count)) + '%)';
      slides.forEach(function (s, si) { s.classList.toggle('is-active', si === index); });
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === index); });
    }
    function next() { goTo(index + 1); }
    function prev() { goTo(index - 1); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() { stop(); if (autoplay) timer = setInterval(next, speed); }

    var prevBtn = root.querySelector('[data-hero-prev]');
    var nextBtn = root.querySelector('[data-hero-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); start(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); start(); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { goTo(parseInt(d.getAttribute('data-hero-dot'), 10)); start(); });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    var touchStartX = null;
    root.addEventListener('touchstart', function (e) { touchStartX = e.touches[0].clientX; stop(); }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (touchStartX === null) return;
      var dx = e.changedTouches[0].clientX - touchStartX;
      if (dx > 40) prev();
      else if (dx < -40) next();
      touchStartX = null;
      start();
    }, { passive: true });

    start();
  });

  // ---------- Auto-rotating announcement bar ----------
  document.querySelectorAll('[data-announce-bar]').forEach(function (bar) {
    var slides2 = Array.prototype.slice.call(bar.querySelectorAll('[data-announce-slide]'));
    if (slides2.length <= 1) return;
    var i2 = 0;
    var speed2 = parseInt(bar.getAttribute('data-speed'), 10) || 4000;
    setInterval(function () {
      slides2[i2].classList.remove('is-active');
      i2 = (i2 + 1) % slides2.length;
      slides2[i2].classList.add('is-active');
    }, speed2);
  });

  // Carousel scroll buttons
  document.querySelectorAll('[data-carousel-left]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var el = document.getElementById(btn.getAttribute('data-carousel-left'));
      if (el) el.scrollBy({ left: -290, behavior: 'smooth' });
    });
  });
  document.querySelectorAll('[data-carousel-right]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var el = document.getElementById(btn.getAttribute('data-carousel-right'));
      if (el) el.scrollBy({ left: 290, behavior: 'smooth' });
    });
  });

  // Wishlist (cosmetic, persisted locally)
  document.querySelectorAll('.wishlist-btn').forEach(function (btn) {
    var id = btn.getAttribute('data-wishlist-id');
    if (!id) return;
    var saved = JSON.parse(localStorage.getItem('petsaus_wishlist') || '[]');
    if (saved.indexOf(id) > -1) btn.classList.add('is-active');
    btn.addEventListener('click', function () {
      var list = JSON.parse(localStorage.getItem('petsaus_wishlist') || '[]');
      var idx = list.indexOf(id);
      if (idx > -1) { list.splice(idx, 1); btn.classList.remove('is-active'); }
      else { list.push(id); btn.classList.add('is-active'); }
      localStorage.setItem('petsaus_wishlist', JSON.stringify(list));
    });
  });

  // ---------- Cart drawer ----------
  var drawer = document.getElementById('cart-drawer');
  var overlay = document.getElementById('cart-drawer-overlay');
  var drawerBody = document.getElementById('cart-drawer-body');
  var drawerFoot = document.querySelector('[data-cart-drawer-foot]');
  var drawerSubtotal = document.querySelector('[data-cart-subtotal]');

  function moneyFormat(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function renderCartLine(item) {
    var variant = item.variant_title && item.variant_title !== 'Default Title'
      ? '<span class="cart-drawer-line-variant">' + item.variant_title + '</span>' : '';
    var img = item.image ? '<img src="' + item.image.replace(/(\.[a-zA-Z0-9]+)(\?.*)?$/, '_160x$1$2') + '" alt="' + (item.title || '') + '">' : '';
    return '' +
      '<div class="cart-drawer-line" data-cart-line data-line-key="' + item.key + '">' +
        '<a href="' + item.url + '">' + img + '</a>' +
        '<div class="cart-drawer-line-body">' +
          '<a href="' + item.url + '" class="cart-drawer-line-title">' + item.product_title + '</a>' +
          variant +
          '<div class="qty-stepper" data-qty-stepper>' +
            '<button type="button" aria-label="Decrease quantity" data-qty-decrease>' + iconSvg('minus') + '</button>' +
            '<input type="number" min="0" value="' + item.quantity + '" aria-label="Quantity" data-qty-input>' +
            '<button type="button" aria-label="Increase quantity" data-qty-increase>' + iconSvg('plus') + '</button>' +
          '</div>' +
          '<button type="button" class="cart-drawer-line-remove" data-cart-remove>Remove</button>' +
        '</div>' +
        '<span class="cart-drawer-line-price">' + moneyFormat(item.final_line_price) + '</span>' +
      '</div>';
  }

  function iconSvg(name) {
    if (name === 'minus') return '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"></path></svg>';
    if (name === 'plus') return '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14"></path><path d="M5 12h14"></path></svg>';
    return '';
  }

  function renderCart(cart) {
    if (!drawerBody) return;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    if (cart.item_count === 0) {
      drawerBody.innerHTML = '<div class="cart-drawer-empty">' + iconCartSvg() + '<p>Your cart is empty.</p><button type="button" class="btn btn-primary" data-cart-drawer-close>Continue Shopping</button></div>';
      if (drawerFoot) drawerFoot.hidden = true;
    } else {
      drawerBody.innerHTML = cart.items.map(renderCartLine).join('');
      if (drawerFoot) drawerFoot.hidden = false;
      if (drawerSubtotal) drawerSubtotal.textContent = moneyFormat(cart.total_price);
    }
    bindCartLineControls();
  }

  function iconCartSvg() {
    return '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="8" cy="21" r="1"></circle><circle cx="19" cy="21" r="1"></circle><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 2-1.58l1.65-7.42H5.12"></path></svg>';
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (res) { return res.json(); });
  }

  function openDrawer() {
    if (!drawer) return;
    fetchCart().then(renderCart);
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.classList.add('cart-drawer-locked');
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.classList.remove('cart-drawer-locked');
  }
  document.querySelectorAll('[data-cart-drawer-close]').forEach(function (el) { el.addEventListener('click', closeDrawer); });
  if (overlay) overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  document.querySelectorAll('[data-open-cart-drawer]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      if (!drawer) return; // no-JS fallback: let the link navigate to /cart
      e.preventDefault();
      openDrawer();
    });
  });

  function updateLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (res) { return res.json(); }).then(renderCart);
  }

  function bindCartLineControls() {
    document.querySelectorAll('[data-cart-line]').forEach(function (line) {
      var key = line.getAttribute('data-line-key');
      var input = line.querySelector('[data-qty-input]');
      var dec = line.querySelector('[data-qty-decrease]');
      var inc = line.querySelector('[data-qty-increase]');
      var remove = line.querySelector('[data-cart-remove]');
      if (dec) dec.addEventListener('click', function () { updateLine(key, Math.max(0, parseInt(input.value, 10) - 1)); });
      if (inc) inc.addEventListener('click', function () { updateLine(key, parseInt(input.value, 10) + 1); });
      if (input) input.addEventListener('change', function () { updateLine(key, Math.max(0, parseInt(input.value, 10) || 0)); });
      if (remove) remove.addEventListener('click', function () { updateLine(key, 0); });
    });
  }
  bindCartLineControls();

  // Quick add / product-form add to cart via AJAX, then open the cart drawer
  document.querySelectorAll('[data-add-to-cart-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[data-add-to-cart-btn]');
      var originalLabel = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: form.querySelector('[name="id"]').value, quantity: parseInt((form.querySelector('[name="quantity"]') || {}).value || 1, 10) }]
        })
      })
        .then(function (res) { if (!res.ok) throw new Error('add failed'); return res.json(); })
        .then(function () { openDrawer(); })
        .then(function () {
          if (btn) { btn.textContent = 'Added ✓'; }
          setTimeout(function () { if (btn) { btn.disabled = false; btn.textContent = originalLabel; } }, 1400);
        })
        .catch(function () {
          if (btn) { btn.disabled = false; btn.textContent = originalLabel; }
          window.location.href = '/cart';
        });
    });
  });

  // Product page variant selection
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var variantsJson = form.getAttribute('data-variants');
    if (!variantsJson) return;
    var variants;
    try { variants = JSON.parse(variantsJson); } catch (e) { return; }
    var priceMapEl = document.getElementById('variant-prices');
    var priceMap = {};
    if (priceMapEl) { try { priceMap = JSON.parse(priceMapEl.textContent); } catch (e) {} }
    var selects = form.querySelectorAll('[data-option-select]');
    var idInput = form.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-product-price]');
    var comparePriceEl = document.querySelector('[data-product-compare-price]');
    var addBtn = form.querySelector('[data-add-to-cart-btn]');

    function currentOptions() {
      return Array.prototype.map.call(selects, function (s) { return s.value; });
    }
    function findVariant() {
      var opts = currentOptions();
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function update() {
      var variant = findVariant();
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      var priceInfo = priceMap[variant.id];
      if (priceInfo) {
        if (priceEl) priceEl.textContent = priceInfo.price;
        if (comparePriceEl) {
          if (priceInfo.compare_at_price) {
            comparePriceEl.textContent = priceInfo.compare_at_price;
            comparePriceEl.hidden = false;
          } else {
            comparePriceEl.hidden = true;
          }
        }
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }
    }
    selects.forEach(function (s) { s.addEventListener('change', update); });
    update();
  });

  // Gallery thumbnails on product page
  document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var src = thumb.getAttribute('data-full-src');
      var main = document.querySelector('[data-gallery-main-img]');
      if (main && src) main.src = src;
      document.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  // ---------- Sliding header on scroll ----------
  (function () {
    var navbar = document.querySelector('.navbar');
    if (!navbar) return;
    var lastY = window.scrollY;
    var topThreshold = 80;
    var delta = 4;
    var scheduled = false;

    function isMenuOpen() {
      var mp = document.getElementById('mobile-panel');
      var sp = document.getElementById('search-panel');
      return (mp && !mp.hidden) || (sp && !sp.hidden);
    }

    function onScroll() {
      scheduled = false;
      var y = window.scrollY;
      if (isMenuOpen()) { lastY = y; return; }
      if (y <= topThreshold) {
        navbar.classList.remove('header-hidden');
      } else if (y > lastY + delta) {
        navbar.classList.add('header-hidden');
      } else if (y < lastY - delta) {
        navbar.classList.remove('header-hidden');
      }
      lastY = y;
    }

    window.addEventListener('scroll', function () {
      if (scheduled) return;
      scheduled = true;
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(onScroll);
      }
      setTimeout(function () { if (scheduled) onScroll(); }, 100);
    }, { passive: true });
  })();

  // ---------- Collection filter toggle (mobile) ----------
  var filterToggle = document.querySelector('[data-filter-toggle]');
  var filterPanel = document.querySelector('[data-filter-panel]');
  if (filterToggle && filterPanel) {
    filterToggle.addEventListener('click', function () { filterPanel.hidden = !filterPanel.hidden; });
  }

  // ---------- Predictive search ----------
  document.querySelectorAll('[data-predictive-search]').forEach(function (wrap) {
    var input = wrap.querySelector('input[type="search"]');
    var results = wrap.querySelector('[data-predictive-results]');
    if (!input || !results) return;
    var timer = null;
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { results.hidden = true; results.innerHTML = ''; return; }
      timer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,query&resources[limit]=6&resources[options][unavailable_products]=last')
          .then(function (res) { return res.json(); })
          .then(function (data) {
            var r = data.resources && data.resources.results;
            if (!r) { results.hidden = true; return; }
            var html = '';
            if (r.collections && r.collections.length) {
              html += '<div class="predictive-group-label">Collections</div>';
              r.collections.forEach(function (c) {
                html += '<a class="predictive-item" href="' + c.url + '"><span class="predictive-item-title">' + c.title + '</span></a>';
              });
            }
            if (r.products && r.products.length) {
              html += '<div class="predictive-group-label">Products</div>';
              r.products.forEach(function (p) {
                var img = p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + '" alt="">' : '';
                html += '<a class="predictive-item" href="' + p.url + '">' + img + '<span><span class="predictive-item-title">' + p.title + '</span><br><span class="predictive-item-price">' + p.price + '</span></span></a>';
              });
            }
            if (!html) {
              html = '<p class="predictive-empty">No results for &ldquo;' + q + '&rdquo;.</p>';
            } else {
              html += '<a class="predictive-view-all" href="/search?q=' + encodeURIComponent(q) + '&type=product">View all results</a>';
            }
            results.innerHTML = html;
            results.hidden = false;
          })
          .catch(function () { results.hidden = true; });
      }, 220);
    });
    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) results.hidden = true;
    });
  });

  // ---------- Product form quantity stepper ----------
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var input = form.querySelector('[data-form-qty-input]');
    var dec = form.querySelector('[data-form-qty-decrease]');
    var inc = form.querySelector('[data-form-qty-increase]');
    if (!input) return;
    if (dec) dec.addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
    if (inc) inc.addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; });
  });

  // ---------- Product recommendations ----------
  var recsEl = document.querySelector('[data-product-recommendations]');
  if (recsEl) {
    var recsUrl = recsEl.getAttribute('data-url');
    if (recsUrl) {
      fetch(recsUrl)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var inner = doc.querySelector('[data-product-recommendations]');
          if (inner && inner.innerHTML.trim()) recsEl.innerHTML = inner.innerHTML;
        })
        .catch(function () {});
    }
  }

  // ---------- Sticky mobile Add to Cart ----------
  var stickyBar = document.querySelector('[data-sticky-atc]');
  var mainForm = document.querySelector('[data-product-form]');
  if (stickyBar && mainForm) {
    var sentinel = document.querySelector('[data-product-form-sentinel]');
    if (sentinel && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
          document.body.classList.toggle('has-sticky-cta-visible', !entry.isIntersecting);
        });
      });
      io.observe(sentinel);
    }
    var stickyBtn = stickyBar.querySelector('[data-sticky-atc-btn]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var realBtn = mainForm.querySelector('[data-add-to-cart-btn]');
        if (realBtn && !realBtn.disabled) realBtn.click();
      });
    }
  }

  // ---------- Recently viewed (localStorage) ----------
  var currentProductHandle = document.body.getAttribute('data-product-handle');
  if (currentProductHandle) {
    var viewed = JSON.parse(localStorage.getItem('petsaus_recently_viewed') || '[]');
    viewed = viewed.filter(function (h) { return h !== currentProductHandle; });
    viewed.unshift(currentProductHandle);
    viewed = viewed.slice(0, 8);
    localStorage.setItem('petsaus_recently_viewed', JSON.stringify(viewed));
  }
  var recentlyViewedEl = document.querySelector('[data-recently-viewed]');
  if (recentlyViewedEl) {
    var stored = JSON.parse(localStorage.getItem('petsaus_recently_viewed') || '[]').filter(function (h) { return h !== currentProductHandle; }).slice(0, 4);
    if (stored.length) {
      Promise.all(stored.map(function (handle) {
        return fetch('/products/' + handle + '.js').then(function (res) { return res.ok ? res.json() : null; }).catch(function () { return null; });
      })).then(function (products) {
        products = products.filter(Boolean);
        if (!products.length) return;
        var grid = recentlyViewedEl.querySelector('[data-recently-viewed-grid]');
        if (!grid) return;
        grid.innerHTML = products.map(function (p) {
          var img = p.featured_image ? '<img src="' + p.featured_image.replace(/(\.[a-zA-Z0-9]+)(\?.*)?$/, '_600x$1$2') + '" alt="' + p.title + '" loading="lazy">' : '';
          var displayPrice = moneyFormat(p.price_varies ? p.price_min : p.price);
          return '<div class="product-card"><div class="product-figure"><a href="' + p.url + '">' + img + '</a></div>' +
            '<div class="product-body"><p class="product-name"><a href="' + p.url + '">' + p.title + '</a></p>' +
            '<div class="price-row"><span class="price-now">' + displayPrice + '</span></div></div></div>';
        }).join('');
        recentlyViewedEl.hidden = false;
      });
    }
  }
});
